import locale4e449542 from '../../../../src/locales/de-DE.json'
import localec28654ec from '../../../../src/locales/en-US.json'
import localee2e93302 from '../../../../src/locales/nl-NL.json'
import locale6e349d82 from '../../../../src/locales/fr-FR.json'
import locale3e2a8182 from '../../../../src/locales/pl-PL.json'
import locale15942242 from '../../../../src/locales/ro-RO.json'
import locale35af4c7f from '../../../../src/locales/es-ES.json'
import locale459e3e42 from '../../../../src/locales/hu-HU.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"deu","file":"de-DE.json","iso":"de-DE","639-1":"de","enabled":true},{"code":"eng","file":"en-US.json","iso":"en-US","639-1":"en","enabled":true},{"code":"nld","file":"nl-NL.json","iso":"nl-NL","639-1":"nl","enabled":false},{"code":"fra","file":"fr-FR.json","iso":"fr-FR","639-1":"fr","enabled":false},{"code":"pol","file":"pl-PL.json","iso":"pl-PL","639-1":"pl","enabled":false},{"code":"ron","file":"ro-RO.json","iso":"ro-RO","639-1":"ro"},{"code":"spa","file":"es-ES.json","iso":"es-ES","639-1":"es"},{"code":"hun","file":"hu-HU.json","iso":"hu-HU","639-1":"hu"}],
  defaultLocale: "deu",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: "/opt/atlassian/pipelines/agent/build/src/locales/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":true,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"deu","file":"de-DE.json","iso":"de-DE","639-1":"de","enabled":true},{"code":"eng","file":"en-US.json","iso":"en-US","639-1":"en","enabled":true},{"code":"nld","file":"nl-NL.json","iso":"nl-NL","639-1":"nl","enabled":false},{"code":"fra","file":"fr-FR.json","iso":"fr-FR","639-1":"fr","enabled":false},{"code":"pol","file":"pl-PL.json","iso":"pl-PL","639-1":"pl","enabled":false},{"code":"ron","file":"ro-RO.json","iso":"ro-RO","639-1":"ro"},{"code":"spa","file":"es-ES.json","iso":"es-ES","639-1":"es"},{"code":"hun","file":"hu-HU.json","iso":"hu-HU","639-1":"hu"}],
  localeCodes: ["deu","eng","nld","fra","pol","ron","spa","hun"],
}

export const localeMessages = {
  'de-DE.json': () => Promise.resolve(locale4e449542),
  'en-US.json': () => Promise.resolve(localec28654ec),
  'nl-NL.json': () => Promise.resolve(localee2e93302),
  'fr-FR.json': () => Promise.resolve(locale6e349d82),
  'pl-PL.json': () => Promise.resolve(locale3e2a8182),
  'ro-RO.json': () => Promise.resolve(locale15942242),
  'es-ES.json': () => Promise.resolve(locale35af4c7f),
  'hu-HU.json': () => Promise.resolve(locale459e3e42),
}
